import type {ReactElement} from 'react';
import React from 'react';
import {BaseStylingOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-styling-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';

export function TextSlideStylingOptions(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const isBold = useGetKeyFromTextStylesOfSelectedTextSlideItem('isBold');
  const isItalic = useGetKeyFromTextStylesOfSelectedTextSlideItem('isItalic');
  const underline = useGetKeyFromTextStylesOfSelectedTextSlideItem('underLine');
  const lineThrough = useGetKeyFromTextStylesOfSelectedTextSlideItem('lineThrough');
  const stroke = useGetKeyFromTextStylesOfSelectedTextSlideItem('stroke');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (activeSlideUID === undefined) {
    throw new Error('active slide uid does not exist');
  }

  if (isBold === undefined || isItalic === undefined || underline === undefined || lineThrough === undefined) {
    throw new Error(`Text Slide doesn't have textStyles property`);
  }

  const onClickBold = (): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      textStyles: {
        isBold: !isBold,
      },
    });
  };

  const onClickItalic = (): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      textStyles: {
        isItalic: !isItalic,
      },
    });
  };

  const onClickStrikeThrough = (): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      textStyles: {
        lineThrough: !lineThrough,
      },
    });
  };

  const onClickUnderline = (): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      textStyles: {
        underLine: !underline,
      },
    });
  };

  return (
    <BaseStylingOptions
      isBold={isBold}
      isBoldDisabled={stroke}
      isItalic={isItalic}
      lineThrough={lineThrough}
      underLine={underline}
      onClickBold={onClickBold}
      onClickItalic={onClickItalic}
      onClickLineThrough={onClickStrikeThrough}
      onClickUnderline={onClickUnderline}
    />
  );
}
